"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var Icon_1 = require("../../../atoms/Icon/Icon");
var Text_1 = __importDefault(require("../../../atoms/Typography/Text"));
var context_1 = require("./context");
var StateTypes;
(function (StateTypes) {
    StateTypes["CURRENT"] = "current";
    StateTypes["AVAILABLE"] = "available";
    StateTypes["FINISHED"] = "finished";
    StateTypes["LOCKED"] = "locked";
})(StateTypes || (StateTypes = {}));
var TopicIcon = function (_a) {
    var state = _a.state;
    var theme = react_1.default.useContext(styled_components_1.ThemeContext);
    switch (state) {
        case StateTypes.CURRENT:
            return (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: "current", color: theme.primaryColor });
        case StateTypes.FINISHED:
            return (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: "finished" });
        case StateTypes.AVAILABLE:
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        default:
            return (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: "lock" });
    }
};
var CourseAgendaTopic = function (_a) {
    var topic = _a.topic, clickable = _a.clickable;
    var _b = (0, context_1.useCourseAgendaContext)(), onTopicClick = _b.onTopicClick, finishedTopicIds = _b.finishedTopicIds, currentNotLockedTopicId = _b.currentNotLockedTopicId, availableTopicsIds = _b.availableTopicsIds;
    var ref = (0, react_1.useRef)(null);
    var isFinished = (0, react_1.useMemo)(function () { return finishedTopicIds.includes(topic.id); }, [finishedTopicIds, topic.id]);
    var isCurrent = (0, react_1.useMemo)(function () { return currentNotLockedTopicId === topic.id; }, [currentNotLockedTopicId, topic.id]);
    (0, react_1.useEffect)(function () {
        var _a;
        if (isCurrent) {
            (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
            });
        }
    }, [ref === null || ref === void 0 ? void 0 : ref.current, isCurrent]);
    var state = (0, react_1.useMemo)(function () {
        if (isCurrent) {
            return StateTypes.CURRENT;
        }
        if (isFinished) {
            return StateTypes.FINISHED;
        }
        if (availableTopicsIds === null || availableTopicsIds === void 0 ? void 0 : availableTopicsIds.includes(topic.id)) {
            return StateTypes.AVAILABLE;
        }
        return StateTypes.LOCKED;
    }, [isFinished, isCurrent, availableTopicsIds]);
    var onClick = (0, react_1.useCallback)(function () {
        if (isCurrent || state === "locked")
            return;
        onTopicClick === null || onTopicClick === void 0 ? void 0 : onTopicClick(topic);
    }, [isCurrent, state]);
    return ((0, jsx_runtime_1.jsx)("li", __assign({ ref: ref, className: "lesson__topic lesson__topic--".concat(state) }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "lesson__description", tabIndex: clickable ? 0 : -1, onClick: function () { return clickable && onClick(); }, onKeyDown: function (e) { return clickable && e.key === "Enter" && onClick(); }, role: "button" }, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ size: "13", noMargin: true, bold: state === "current" }, { children: topic.title })), (0, jsx_runtime_1.jsx)(TopicIcon, { state: state })] })) })));
};
exports.default = CourseAgendaTopic;
